module.exports = __webpack_public_path__ + "media/images/default/join_us/it-ee36ce2f8afcd81cb27b932a9101691a.jpg";